import React, { useState } from 'react';
import './SignUp.css';
import { auth, db } from '../firebase/firebaseConfig';
import { createUserWithEmailAndPassword, updateProfile } from 'firebase/auth';
import { useNavigate, Link } from 'react-router-dom';
import { doc, setDoc } from 'firebase/firestore';

const SignUp = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    role: 'user', // default role
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password.length < 8 || !/\d/.test(formData.password)) {
      alert('Password must be at least 8 characters long and include a number.');
      return;
    }

    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        formData.email,
        formData.password
      );

      const user = userCredential.user;

      await updateProfile(user, {
        displayName: `${formData.firstName} ${formData.lastName}`,
      });

      await setDoc(doc(db, 'users', user.uid), {
        uid: user.uid,
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        role: formData.role,
        createdAt: new Date().toISOString(),
      });

      alert('Signup successful! You can now log in.');
      navigate('/login');
    } catch (error) {
      console.error('Signup Error:', error.message);
      alert(error.message);
    }
  };

  const backgroundImage =
    'https://static.vecteezy.com/system/resources/thumbnails/024/494/104/small_2x/abstract-light-background-blue-background-with-waves-free-photo.jpg';

  const leftImage =
    'https://www.shutterstock.com/shutterstock/photos/1842408310/display_1500/stock-vector-lost-and-found-service-concept-with-cartoon-characters-loosing-baggage-while-airline-flight-1842408310.jpg';

  const rightImage =
    'https://img.freepik.com/premium-vector/cartoon-young-man-returning-lost-wallet-lost-found-service_341509-1088.jpg?w=360';

  return (
    <div
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'row',
        position: 'relative',
      }}
    >
      {/* Overlay */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          height: '100%',
          width: '100%',
          backgroundColor: 'rgba(255, 255, 255, 0.6)',
          zIndex: 1,
        }}
      />

      {/* Left image */}
      <div
        style={{
          flex: 1,
          zIndex: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '1rem',
        }}
      >
        <img
          src={leftImage}
          alt="Lost item"
          style={{
            width: '220px',
            height: 'auto',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
          }}
        />
      </div>

      {/* Form Center */}
      <div
        style={{
          flex: 2,
          zIndex: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '60px 0',
        }}
      >
        <form
          className="signup-form"
          onSubmit={handleSubmit}
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            padding: '2rem',
            borderRadius: '12px',
            boxShadow: '0 8px 20px rgba(0,0,0,0.2)',
            width: '100%',
            maxWidth: '450px',
          }}
        >
          <h2>Sign Up</h2>
          <input
            type="text"
            name="firstName"
            placeholder="First Name"
            value={formData.firstName}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="lastName"
            placeholder="Last Name"
            value={formData.lastName}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
            required
          />

          {/* Role Selection Dropdown */}
          <label htmlFor="role" style={{ marginTop: '10px' }}>
            Select Role:
          </label>
          <select
            name="role"
            value={formData.role}
            onChange={handleChange}
            required
            style={{
              padding: '8px',
              borderRadius: '6px',
              marginBottom: '10px',
              marginTop: '4px',
              width: '100%',
            }}
          >
            <option value="user">Normal User</option>
            <option value="security">Security Officer</option>
            <option value="admin">Admin</option>
          </select>

          <button type="submit">Register</button>

          <p style={{ marginTop: '1rem' }}>
            Already have an account? <Link to="/login">Log In</Link>
          </p>
        </form>
      </div>

      {/* Right image */}
      <div
        style={{
          flex: 1,
          zIndex: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '1rem',
        }}
      >
        <img
          src={rightImage}
          alt="Found item"
          style={{
            width: '220px',
            height: 'auto',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
          }}
        />
      </div>
    </div>
  );
};

export default SignUp;
